/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_Sign_Up_TitleInputs */

const en_common_sign_sign_up_title = /** @type {(inputs: Common_Sign_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign Up`)
};

const zh_common_sign_sign_up_title = /** @type {(inputs: Common_Sign_Sign_Up_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注册`)
};

/**
* | output |
* | --- |
* | "Sign Up" |
*
* @param {Common_Sign_Sign_Up_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_sign_up_title = /** @type {((inputs?: Common_Sign_Sign_Up_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Sign_Up_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_sign_up_title(inputs)
	return zh_common_sign_sign_up_title(inputs)
});
export { common_sign_sign_up_title as "common.sign.sign_up_title" }